import React, { useEffect, useState } from "react";

import Message from "../../Message";
import SuccessRes from "./SuccessRes";
import {
  addRecordSchema,
  updateRecordSchema,
} from "../../../../joi/exportTabSchema";

import { createRecordSetData } from "../../../../../context/api/records/export-tab/create-record/createRecordSetData";
import { updateRecordSetData } from "../../../../../context/api/records/export-tab/update-record/updateRecordSetData";
import { useValidator } from "react-joi";
import { useCookies } from "react-cookie";
import { joiErrorMessage } from "../../../extra/joiErrorMessage";
// Bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
// Context
import { getEXRSetData } from '../../../../../context/api/settings/get-values/get-exchange-rate-add-record/getEXRSetData';



const CreateRecordModal = ({
  show,
  onHide,
  lang,
  action,
  data,
  userId,
  setRefreshData,
}) => {
  const dataTranslate = require(`../../../../../translate/${lang === "AR" ? "arabic" : "english"
    }/data.json`);

  var schema =
    action === "update"
      ? updateRecordSchema(lang).schema
      : addRecordSchema(lang).schema;

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const initialSuccessMessage = {
    success: false,
    type: "",
    message: "",
    data: {},
  };

  const { state, setData, setExplicitField, validate, reset } =
    useValidator(schema);
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
  const [cookies] = useCookies();
  const [btnLoader, setBtnLoader] = useState(false);
  const [EXRLoading, setEXRLoading] = useState(false);
  const [EXRData, setEXRData] = useState([]);
  const createRecord = (e) => {
    e.preventDefault();

    let credintial = {};
    for (const item in state.$data) {
      if (state.$data[item] != null) {
        credintial[item] = state.$data[item];
      }
    }
    // remove any empty value
    for (const item in credintial) {
      if (state.$data[item] === "") {
        delete credintial[item];
      }
    }

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return createRecordSetData(
        lang,
        setMessageResponse,
        cookies,
        credintial,
        setSuccessMessage,
        setBtnLoader,
        userId
      );
    }
  };

  const updateRecord = (e) => {
    e.preventDefault();
    const userId = data.id;
    let credintial = {};
    for (const item in state.$data) {
      if (state.$data[item] != null) {
        credintial[item] = state.$data[item];
      }
    }
    // console.log(Object.keys(credintial).length);
    // return;

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return updateRecordSetData(
        lang,
        setMessageResponse,
        cookies,
        credintial,
        setSuccessMessage,
        setBtnLoader,
        userId
      );
    }
  };
  useEffect(() => {
    const fetch = async () => {
      setEXRData([]);
      await getEXRSetData(lang, setMessageResponse, cookies, setEXRData, setEXRLoading, setData);
    }
    if (show == true && action == "add") {
      fetch();
    }
  }, [show]);
  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="forget-pass-otp-form"
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {successMessage.success ? (
          <SuccessRes
            lang={lang}
            dataTranslate={dataTranslate}
            onHide={async () => {
              await onHide();
              setSuccessMessage(initialSuccessMessage);
              setRefreshData((prev) => prev + 1);
            }}
            res={successMessage}
          />
        ) : (
          <>
            <Modal.Header className="d-flex align-items-center justify-content-center ">
              <Modal.Title
                id="contained-modal-title-vcenter"
                className="fs-2 d-flex flex-row gap-2"
              >
                <span>
                  {action === "add"
                    ? dataTranslate.popups.exports_tab.records.add_title
                    : action === "update"
                      ? dataTranslate.popups.exports_tab.records.update_title
                      : ""}
                </span>
                {action === "update" ? (
                  <span style={{ color: "red" }}>{data.id}</span>
                ) : (
                  ""
                )}
              </Modal.Title>
            </Modal.Header>
            {!EXRLoading && action == "add" ? <>
              <div className="menuLoader">
                <Spinner animation="border" variant="warning" />
              </div>
            </> : ""}
            <Modal.Body className="mx-5">
              <div dir={lang === "AR" ? "rtl" : ""}>
                <Container>
                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.amount}
                          {action === "add" ? (
                            <span>
                              <sup style={{ color: "red" }}> *</sup>
                            </span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <Form.Control
                          disabled={!EXRLoading && action == "add" ? true : false}
                          placeholder={
                            dataTranslate.popups.exports_tab.records.amount_p
                          }
                          defaultValue={action === "update" ? data.amount : ""}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              amount: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("amount", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.amount)}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.vendorName}
                        </Form.Label>
                        <Form.Control
                          disabled={!EXRLoading && action == "add" ? true : false}
                          placeholder={
                            dataTranslate.popups.exports_tab.records
                              .vendorName_p
                          }
                          defaultValue={
                            action === "update" ? data.vendorName : ""
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              vendorName: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("vendorName", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.vendorName)}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {
                            dataTranslate.popups.exports_tab.records
                              .invoiceNumber
                          }
                        </Form.Label>
                        <Form.Control
                          disabled={!EXRLoading && action == "add" ? true : false}
                          placeholder={
                            dataTranslate.popups.exports_tab.records
                              .invoiceNumber_p
                          }
                          defaultValue={
                            action === "update" ? data.invoiceNumber : ""
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              invoiceNumber: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("invoiceNumber", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.invoiceNumber)}
                        </Form.Text>
                      </Form.Group>
                    </Col>

                    <Col lg={6} sm={12} className=" mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {
                            dataTranslate.popups.exports_tab.records.payMethod
                              .title
                          }
                          {action === "add" ? (
                            <span>
                              <sup style={{ color: "red" }}> *</sup>
                            </span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <Form.Select
                          disabled={!EXRLoading && action == "add" || action == "update"? true : false}
                          defaultValue={
                            action === "update" ? data.payMethodNative : ""
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              payMethod: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("payMethod", true)}
                        >
                          <option selected>
                            {
                              dataTranslate.popups.exports_tab.records.payMethod
                                .choose
                            }
                          </option>
                          <option value="on-us">
                            {
                              dataTranslate.popups.exports_tab.records.payMethod
                                .on_us
                            }
                          </option>
                          <option value="off-us">
                            {
                              dataTranslate.popups.exports_tab.records.payMethod
                                .off_us
                            }
                          </option>
                        </Form.Select>

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.payMethod)}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.exchangeRateRMB}
                          {action === "add" ? (
                            <span>
                              <sup style={{ color: "red" }}> *</sup>
                            </span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <Form.Control
                          disabled={!EXRLoading && action == "add" ? true : false}
                          type="number"
                          placeholder={
                            dataTranslate.popups.exports_tab.records.exchangeRateRMB_p
                          }
                          defaultValue={action === "update" ? data.exchangeRateRMB : EXRData}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              exchangeRateRMB: parseFloat(e.target.value),
                            }));
                          }}
                          onKeyUp={(e) => {
                            setData((old) => ({
                              ...old,
                              exchangeRateRMB: parseFloat(e.target.value),
                            }))
                          }}
                          onBlur={() => setExplicitField("exchangeRateRMB", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.exchangeRateRMB)}
                        </Form.Text>
                      </Form.Group>
                    </Col>















                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.totalBoxs}
                        </Form.Label>
                        <Form.Control
                          disabled={!EXRLoading && action == "add" ? true : false}
                          placeholder={
                            dataTranslate.popups.exports_tab.records.totalBoxs
                          }
                          defaultValue={
                            action === "update" ? data.totalBoxs : 0
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              totalBoxs: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("totalBoxs", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.totalBoxs)}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className=" mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.totalPeices}
                        </Form.Label>
                        <Form.Control
                          disabled={!EXRLoading && action == "add" ? true : false}
                          placeholder={
                            dataTranslate.popups.exports_tab.records.totalPeices
                          }
                          defaultValue={
                            action === "update" ? data.totalPeices : 0
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              totalPeices: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("totalPeices", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.totalPeices)}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.vendorPhoneNumber}
                        </Form.Label>
                        <Form.Control
                          disabled={!EXRLoading && action == "add" ? true : false}
                          placeholder={
                            dataTranslate.popups.exports_tab.records
                              .vendorPhoneNumber_p
                          }
                          defaultValue={
                            action === "update" ? data.vendorPhoneNumber : ""
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              vendorPhoneNumber: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("vendorPhoneNumber", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.vendorPhoneNumber)}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.recordDate}
                          {action === "add" ? (
                            <span>
                              <sup style={{ color: "red" }}> *</sup>
                            </span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <Form.Control
                          type="date"
                          disabled={!EXRLoading && action == "add" ? true : false}
                          defaultValue={action === "update" ? data.recordDateYYYYMMDD : ""}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              recordDate: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("recordDate", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.recordDate)}
                        </Form.Text>
                      </Form.Group>
                    </Col>

                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.notes}
                        </Form.Label>
                        <Form.Control
                          disabled={!EXRLoading && action == "add" ? true : false}
                          as="textarea"
                          placeholder={
                            dataTranslate.popups.exports_tab.records.notes
                          }
                          defaultValue={action === "update" ? data.NB : ""}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              NB: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("NB", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.NB)}
                        </Form.Text>
                      </Form.Group>
                    </Col>

                  </Row>
                </Container>
              </div>
            </Modal.Body>
            <Modal.Footer
              className="w-100 d-flex flex-row align-items-center"
              dir="ltr"
            >
              <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
                {action === "add" ? (
                  <Button
                    onClick={(e) => {
                      validate();
                      createRecord(e);
                    }}
                    disabled={(!EXRLoading && action == "add" || btnLoader) ? true : false}
                  >
                    {dataTranslate.popups.exports_tab.records.add}
                  </Button>
                ) : action === "update" ? (
                  <Button
                    onClick={(e) => {
                      validate();
                      updateRecord(e);
                    }}

                    disabled={btnLoader ? true : false}
                  >
                    {dataTranslate.popups.exports_tab.records.update}
                  </Button>
                ) : (
                  ""
                )}

                <Button
                  onClick={() => {
                    reset();
                    onHide();
                    setEXRData([]);
                    setEXRLoading(false);
                  }}
                  style={{ zIndex: 1000 }}
                >
                  {dataTranslate.popups.exports_tab.records.close}
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default CreateRecordModal;
